import { getCountLinkParams } from "../getCountLinkParams";
export const getOutrightCountLinkParams = (props) => {
    return Object.assign(Object.assign({}, getCountLinkParams(props)), { count: props.markets[0].selections.length });
};
//# sourceMappingURL=getOutrightCountLinkParams.js.map